import { useState } from "react";

export const fieldCls =
  "w-full rounded-lg border border-[#0f2544]/15 bg-white px-3 py-2 text-sm outline-none focus:border-[#1f44e0] transition-colors";
export const labelCls = "block text-sm font-medium text-[#0f2544] mb-1";

export function ImageHint({ children }) {
  return (
    <div className="rounded-lg bg-[#eef1ff] border border-[#1f44e0]/20 px-3 py-2 text-xs text-[#0f2544] mb-2" data-testid="image-hint">
      {children}
    </div>
  );
}

export function AdminHeader({ title, subtitle, action }) {
  return (
    <div className="flex items-start justify-between mb-6">
      <div>
        <h1 className="font-serif text-3xl text-[#0f2544]">{title}</h1>
        {subtitle && <p className="text-[#8a8a83] mt-1">{subtitle}</p>}
      </div>
      {action}
    </div>
  );
}

export function PrimaryBtn({ children, onClick, type = "button", testId, disabled }) {
  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled}
      className="inline-flex items-center gap-2 rounded-lg bg-[#0f2544] px-4 py-2.5 text-xs font-semibold tracking-[0.1em] text-white hover:bg-[#1f44e0] transition-colors disabled:opacity-60"
      data-testid={testId}
    >
      {children}
    </button>
  );
}

export function Modal({ open, onClose, title, children, wide }) {
  if (!open) return null;
  return (
    <div className="fixed inset-0 z-[60] flex items-start justify-center bg-black/40 p-4 overflow-y-auto" onClick={onClose}>
      <div
        className={`bg-white rounded-xl w-full ${wide ? "max-w-3xl" : "max-w-lg"} my-8`}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex items-center justify-between px-6 py-4 border-b border-[#0f2544]/8">
          <h2 className="font-serif text-xl text-[#0f2544]">{title}</h2>
          <button onClick={onClose} className="text-[#8a8a83] hover:text-[#0f2544] text-xl leading-none" data-testid="modal-close">×</button>
        </div>
        <div className="p-6">{children}</div>
      </div>
    </div>
  );
}

export function useToggle(init = false) {
  const [v, setV] = useState(init);
  return [v, () => setV(true), () => setV(false), setV];
}
